import { useResponsiveContainer } from 'src/contexts/ResponsiveContainerContext'
import { useTranscriptMetadata } from 'src/contexts/Transcript/MetadataContext'
import { getSessionTitle } from 'src/models/TranscriptMetadata'

import * as S from './styles'

export const ReadyToConnectTemplate = () => {
    const { isMediumContainer } = useResponsiveContainer()
    const metadata = useTranscriptMetadata()
    const sessionTitle = getSessionTitle(metadata)

    return (
        <S.ReadyToConnectContent>
            {isMediumContainer ? (
                // A nameless session must not emit an empty heading, but this box's `marginBottom: auto`
                // is what pins the rest of the column, so keep the box and drop only the heading role.
                <S.ReadyToConnectSessionTitle as={sessionTitle ? 'h2' : 'div'}>{sessionTitle}</S.ReadyToConnectSessionTitle>
            ) : (
                <S.StyledTranscriptIcon />
            )}
            <S.TemplateTitle>Ready when you are</S.TemplateTitle>
            <S.TemplateDescription>
                Simply press the record button at the {isMediumContainer ? 'bottom' : 'top left'} to begin recording
            </S.TemplateDescription>
        </S.ReadyToConnectContent>
    )
}
